<template>
    <main class="bg-white">
        <div class="relative flex">
            <!-- Content -->
            <div class="w-full">
                <div class="flex h-full min-h-screen flex-col after:flex-1">
                    <div class="flex h-screen flex-col">
                        <!-- Content area -->
                        <div class="my-auto">
                            <div class="mx-auto w-full max-w-9xl px-4 py-8 sm:px-6 lg:px-8">
                                <div class="m-auto max-w-2xl">
                                    <div class="mb-16 px-4 text-center">
                                        <div class="mb-8 inline-flex">
                                            <img
                                                src="@/images/404-illustration.svg"
                                                width="176"
                                                height="176"
                                                alt="404 illustration"
                                            />
                                        </div>
                                        <h2 class="mb-2 text-2xl font-bold text-slate-800"> {{ messageMap[reason].title }}</h2>
                                        <div class="mb-6">
                                            {{ messageMap[reason].message }}
                                        </div>

                                        <!-- We use an a tag to reload the whole page -->
                                        <a href="/" class="btn bg-indigo-500 text-white hover:bg-indigo-600 mr-4"
                                            >Back To Dashboard
                                        </a>
                                        <button class="btn bg-indigo-500 text-white hover:bg-indigo-600 ml-4" @click="onContactUs()">
                                            Contact Support
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: 'NoAccessPage',

    components: {},

    data() {
        return {
            reason: this.$route.query.reason || 'unknown',
            messageMap: {
                'timeout': {
                    title: 'Something\'s Taking Too Long',
                    message: 'We\'re having trouble loading your account permissions. This could be due to a slow connection or temporary issue. Please try refreshing the page. If the problem continues, contact support.',
                },
                'permission-denied': {
                    title: 'You Don\'t Have Permission to View This Page',
                    message: 'Your account doesn\'t have the necessary permissions to access this page. If you believe this is an error, please contact your organization owner.',
                },
                'no-modules': {
                    title: 'You Don\'t Have Access to Any Features',
                    message: 'You\'re logged in, but your account doesn\'t currently have access to any parts of the platform. Please reach out to your organization owner to request access, or contact support if you think this is a mistake.',
                },
                'unknown': {
                    title: 'Connection Issue',
                    message: 'We\'re having trouble connecting to the server. Please check your internet connection and try again. If the issue persists, contact support.',
                }
            },
        }
    },

    methods: {
        onContactUs() {
            this.intercomModule.show()
        },
    },
}
</script>
